
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.943 4.525a5.255 5.255 0 00-6-.997l3.5 3.489-2.42 2.413-3.5-3.49a5.218 5.218 0 001.008 5.974 5.258 5.258 0 005.557 1.19L18.008 21 21 18.017l-7.888-7.872a5.22 5.22 0 00-1.169-5.62z","fill-rule":"nonzero"}})])
          )
        }
      }
    